module.exports = __webpack_public_path__ + "img/bryan-kelly-sm.b773c56.png";